/** Build CSS viewport key: minWxmaxH@dpr (matches build script viewport map). */
export function buildViewportKey(
  width: number,
  height: number,
  devicePixelRatio: number,
): string {
  const w = Math.round(Math.min(width, height));
  const h = Math.round(Math.max(width, height));
  const dpr = Number.isInteger(devicePixelRatio)
    ? String(devicePixelRatio)
    : String(devicePixelRatio);
  return `${w}x${h}@${dpr}`;
}

export function readViewportKey(): string | null {
  if (typeof window === 'undefined' || typeof screen === 'undefined') return null;

  const width = window.screen.width;
  const height = window.screen.height;
  const dpr = window.devicePixelRatio || 1;

  if (!width || !height) return null;
  return buildViewportKey(width, height, dpr);
}
